import { useState, useEffect, Fragment } from "react";
import Select from "react-select";
import {
    addUser,
} from "../../../../../actions/admin/quotation";
import {
    getLocationByAddress
} from "../../../../../actions/googleAPI";
import AdminModal from "../../../components/AdminModal";
import AdminInput from "../../../components/AdminInput";
import { RadioSelectedIcon, RadioUnselectedIcon } from "../../../../icons";
import CountryFlag from "../../../../common/CountryFlag";

const AddClientModal = ({ show, onClose, onSuccessAddNewClient, onFailedAddNewClient }) => {
    const PRONOUNCE = [
        {
            label: "-",
            value: "-",
        },
        {
            label: "Mr.",
            value: "Mr.",
        },
        {
            label: "Ms.",
            value: "Ms.",
        },
        {
            label: "Mrs.",
            value: "Mrs.",
        },
        {
            label: "Mr./Ms.",
            value: "Mr./Ms.",
        },
    ];

    const [searchPhoneCode, setSearchPhoneCode] = useState(null);
    const [addUserForm, setAddUserForm] = useState({
        type: "individual",
        honorific: "Mr.",
        name: "",
        email: "",
        prefixNumber: "+81",
        phoneNumber: "",
        country: "Japan",
        countryCode: "JP",
        postalCode: "",
        billingAddress: "",
        city: ""
    });
    const [countriesData, setCountriesData] = useState([]);
    const [isCityDisable, setIsCityDisable] = useState(true);
    const [isPostalCodeDisable, setIsPostalCodeDisable] = useState(false);
    const [formValidation, setFormValidation] = useState({
        email: true,
        billingAddress: true,
        name: true
    })

    const checkValidation = async () => {
        setFormValidation({
            ...formValidation,
            email: addUserForm.email !== ""
        })

        return (
            addUserForm.email !== ""
        )
    }

    const loadCountriesData = () => {
        fetch("/json/countries.json") // Replace with the actual path to your JSON file
            .then((response) => response.json())
            .then((data) => setCountriesData(data))
            .catch((error) => console.error("Error loading JSON data:", error));
    };

    useEffect(() => {
        loadCountriesData();
    }, []);

    const customStylesSelect = {
        control: (provided) => ({
            ...provided,
            minHeight: "48px",
            height: "38px",
            marginTop: "10px",
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: "38px",
            padding: "0 8px",
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: "38px",
        }),
    };

    const handleChangeNewClientForm = (e) => {
        if (e.target.name === "name" || e.target.name === "billingAddress") {
            const invalidChars = e.target.value.split('').filter(char =>
                !/[\w\s!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/.test(char)
            );

            if (e.target.value === "") {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: true
                })
            } else if (invalidChars.length > 0) {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: false
                })
            } else {
                setFormValidation({
                    ...formValidation,
                    [e.target.name]: true
                })
            }
        }

        setAddUserForm({ ...addUserForm, [e.target.name]: e.target.value });
    }

    const handleAddUserChangeCountryCode = (dialCode, countryCode, name) => {
        setAddUserForm({
            ...addUserForm,
            country: name,
            countryCode: countryCode,
            prefixNumber: dialCode,
        });
    };

    const submitAddUser = async () => {
        try {
            const validationStatus = await checkValidation();

            if (validationStatus) {
                const response = await addUser(addUserForm);
                alert("Success Add Client!");
                setAddUserForm({
                    type: "individual",
                    honorific: "Mr.",
                    name: "",
                    email: "",
                    prefixNumber: "+81",
                    phoneNumber: "",
                    country: "Japan",
                    countryCode: "JP",
                    postalCode: "",
                    billingAddress: "",
                });

                onSuccessAddNewClient(response);
            }
        } catch (e) {
            onFailedAddNewClient(e);
        }
    };

    const checkPostalCode = async () => {
        try {
            const zipCodeCheck = await getLocationByAddress(addUserForm.postalCode, addUserForm.countryCode);

            let city
            if (zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality")).length !== 0) {
                city = zipCodeCheck.address_components.filter(item => item.types.includes("administrative_area_level_2") || item.types.includes("locality"))[0].long_name
            } else {
                city = zipCodeCheck.address_components[zipCodeCheck.address_components.length - 2].long_name
            }

            setAddUserForm({
                ...addUserForm,
                city
            })
        } catch (e) {
            onFailedAddNewClient(e);
        }
    };

    useEffect(() => {
        const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE;

        if (!countryWithoutPostCode.split(',').includes(addUserForm.countryCode)) {
            setIsPostalCodeDisable(false);
            setIsCityDisable(true);
            setAddUserForm({
                ...addUserForm,
                postalCode: "",
                city: "",
            })
        } else {
            setAddUserForm({
                ...addUserForm,
                postalCode: "-",
                city: "",
            })
            setIsPostalCodeDisable(true);
            setIsCityDisable(false);
        }
    }, [addUserForm.countryCode]);

    const checkPostalCodeHandler = async () => {
        await checkPostalCode();
    }

    return (
        <AdminModal
            show={show}
            title="Add Client"
            size="modal-lg"
            onClose={onClose}
            description={"Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"}
        >
            <div className="row mb-3 px-2">
                <div className="col-6 m-0 p-0 pe-1">
                    <div
                        className={`rounded w-100 ${addUserForm.type === "individual"
                            ? "border-gold"
                            : "border-gold-100"
                            } p-3 pointer hover`}
                        onClick={() => handleChangeNewClientForm({ target: { name: "type", value: "individual" } })}
                    >
                        <div className="d-flex gap-2 align-items-center">
                            {addUserForm.type === "individual"
                                ? <RadioSelectedIcon />
                                : <RadioUnselectedIcon />}
                            <p className={`m-0 ${addUserForm.type === "individual" && "fw-bold"}`}>
                                Individual
                            </p>
                        </div>
                    </div>
                </div>
                <div className="col-6 m-0 p-0 ps-1">
                    <div
                        className={`rounded w-100 ${addUserForm.type === "business"
                            ? "border-gold"
                            : "border-gold-100"
                            } p-3 pointer hover`}
                        onClick={() => handleChangeNewClientForm({ target: { name: "type", value: "business" } })}
                    >
                        <div className="d-flex gap-2 align-items-center">
                            {addUserForm.type === "business"
                                ? <RadioSelectedIcon />
                                : <RadioUnselectedIcon />}
                            <p className={`m-0 ${addUserForm.type === "business" && "fw-bold"}`}>
                                Business
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row px-2">
                <div className="col-3 m-0 p-0 pe-1">
                    <p className="mb-2">Honorifics</p>
                    <Select
                        options={PRONOUNCE}
                        onChange={(e) => handleChangeNewClientForm({ target: { name: "honorific", value: e.value } })}
                        styles={customStylesSelect}
                        name="honorific"
                    />
                </div>
                <div className="col m-0 p-0 ps-1">
                    <label className="mb-2 fs-14">Name</label>
                    <AdminInput
                        placeholder="Name"
                        value={addUserForm.name}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="name"
                        isInvalid={!formValidation.name}
                        invalidMessage="Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"
                    />
                </div>
            </div>
            <div className="row px-2">
                <div className="col-6 m-0 p-0 pe-1">
                    <label className="mb-2 fs-14">Email</label>
                    <AdminInput
                        placeholder="Email"
                        value={addUserForm.email}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="email"
                        type="email"
                        isInvalid={!formValidation.email}
                        invalidMessage={"Please fill in email address."}
                    />
                </div>
                <div className="col-6 m-0 p-0 ps-1">
                    <label className="mb-2 fs-14">Phone No.</label>
                    <div className="d-flex">
                        <button
                            className="btn bg-gold-light-100 fw-100 rounded noto dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ width: "130px" }}
                        >
                            <CountryFlag
                                code={addUserForm.countryCode}
                                emoji={countriesData?.find((c) => c.code === addUserForm.countryCode)?.flag}
                                alt=""
                            />{" "}
                            ({addUserForm.prefixNumber})
                        </button>
                        <ul className="dropdown-menu">
                            <div className="px-1 align-items-center mb-3 dropdown-search">
                                <input
                                    placeholder={"Please type in your country name"}
                                    type="text"
                                    className={`form-control p-3 mb-2`}
                                    defaultValue={searchPhoneCode}
                                    onChange={(e) => setSearchPhoneCode(e.target.value)}
                                />
                            </div>
                            {searchPhoneCode !== null
                                ? countriesData
                                    ?.filter((item) => {
                                        const searchValue =
                                            searchPhoneCode?.toLowerCase() || "";
                                        return (
                                            item.name.toLowerCase().includes(searchValue) ||
                                            item.dial_code.toLowerCase().includes(searchValue)
                                        );
                                    })
                                    ?.map((country, index) => (
                                        <Fragment key={country.code}>
                                            <li
                                                className="dropdown-item m-0"
                                                onClick={() =>
                                                    handleAddUserChangeCountryCode(
                                                        country.dial_code,
                                                        country.code,
                                                        country.name
                                                    )
                                                }
                                            >
                                                <div className="row px-1 align-items-center">
                                                    <div className="col-auto">
                                                        <div className="bg-secondary bg-opacity-25 px-1">
                                                            <CountryFlag
                                                                code={country.code}
                                                                emoji={country.flag}
                                                                alt={country.name}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col">
                                                        ({country.dial_code}) {country.name}
                                                    </div>
                                                </div>
                                            </li>
                                            <hr className="my-1" />
                                        </Fragment>
                                    ))
                                : countriesData?.map((country, index) => (
                                    <Fragment key={country.code}>
                                        <li
                                            className="dropdown-item m-0"
                                            onClick={() =>
                                                handleAddUserChangeCountryCode(
                                                    country.dial_code,
                                                    country.code,
                                                    country.name
                                                )
                                            }
                                        >
                                            <div className="row px-1 align-items-center">
                                                <div className="col-auto">
                                                    <div className="bg-secondary bg-opacity-25 px-1">
                                                        <CountryFlag
                                                            code={country.code}
                                                            emoji={country.flag}
                                                            alt={country.name}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    ({country.dial_code}) {country.name}
                                                </div>
                                            </div>
                                        </li>
                                        <hr className="my-1" />
                                    </Fragment>
                                ))}
                        </ul>
                        <AdminInput
                            placeholder="Phone No."
                            value={addUserForm.phoneNumber}
                            onChange={(e) => handleChangeNewClientForm(e)}
                            name="phoneNumber"
                            mb="mb-0 w-100"
                        />
                    </div>
                </div>
            </div>
            <div className="row px-2">
                <div className="col-4 m-0 p-0 pe-1">
                    <label className="mb-2 fs-14">Country</label>
                    <AdminInput
                        placeholder="Country"
                        value={addUserForm.country}
                        onChange={() => { }}
                        name="country"
                        disable={true}
                    />
                </div>
                <div className="col-4 m-0 p-0 px-1">
                    <label className="mb-2 fs-14">Postal Code</label>
                    <AdminInput
                        placeholder="Postal Code"
                        value={addUserForm.postalCode}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="postalCode"
                        disable={isPostalCodeDisable}
                        onBlur={checkPostalCodeHandler}
                    />
                </div>
                <div className="col-4 m-0 p-0">
                    <label className="mb-2 fs-14">City</label>
                    <AdminInput
                        placeholder="City"
                        value={addUserForm.city}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="city"
                        disable={isCityDisable}
                    />
                </div>
            </div>
            <div className="row px-2">
                <div className="col-12 m-0 p-0">
                    <label className="mb-2 fs-14">Billing Address</label>
                    <AdminInput
                        placeholder="Billing Address"
                        value={addUserForm.billingAddress}
                        onChange={(e) => handleChangeNewClientForm(e)}
                        name="billingAddress"
                        isInvalid={!formValidation.billingAddress}
                        invalidMessage="Kindly enter the client’s name and address using the Roman alphabet only (e.g., Tanaka Taro)"
                    />
                </div>
            </div>

            <div className="d-grid mt-3">
                <button
                    className="btn rounded bg-gold py-2"
                    onClick={submitAddUser}
                >
                    <span className="text-white">Save </span>
                </button>
            </div>
        </AdminModal>
    )
}

export default AddClientModal